module.exports = __webpack_public_path__ + "img/step2_en-GB.61f737e8.png";